import notificationStreamModule from "../notificationStreamModule";

function friendRequest(notificationStreamUtility, $log, thumbnailConstants) {
    "ngInject";

    return {
        restrict: "A",
        replace: true,
        scope: {
            notification: "=",
            library: "=",
            appMeta: "=",
            acceptFriend: "&",
            ignoreFriend: "&",
            chat: "&",
            interactNotification: "&"
        },
        templateUrl: notificationStreamUtility.templates.friendRequestTemplate,
        link: function (scope, element, attrs) {
            scope.notificationSourceType = notificationStreamUtility.notificationSourceType;
            scope.friendRequestLink = notificationStreamUtility.layout.friendRequestLink;
            var metaData = scope.notification.metadataCollection;
            var notificationType = scope.notification.notificationSourceType;
            var length = metaData.length;
            var count = scope.notification.eventCount ? scope.notification.eventCount : length;
            var textHeader = "";
            var userOne = "";
            var userTwo = "";

            var textFormat = function () {
                scope.userIds = [];
                scope.notificationDisplayText = "";
                metaData.forEach(function (data, index) {
                    var user = notificationStreamUtility.normalizeUser(notificationType, data);
                    var userId = user.userId;
                    var userName = user.userName;
                    var displayName = user.displayName;
                    var profileLink = scope.library.userLibrary[userId] && scope.library.userLibrary[userId].profileLink ?
                        scope.library.userLibrary[userId].profileLink : notificationStreamUtility.getAbsoluteUrl(notificationStreamUtility.links.profileLink, { id: userId });
                    if (scope.userIds.indexOf(userId) < 0) {
                        scope.userIds.push(userId);
                    }
                    var htmlTemplate = notificationStreamUtility.getUserHtmlTemplate(notificationType, count);
                    var html = notificationStreamUtility.getFormatString(htmlTemplate, { userId: userId, userName: userName, displayName: displayName, profileLink: profileLink });
                    if (index < 1) {
                        textHeader += html;
                        userOne += html;
                    } else if (index < 2) {
                        userTwo += html;
                        if (count > 2) {
                            textHeader += ", " + html + ", ";
                        } else if (count === 2) {
                            textHeader += " and " + html;
                        }
                    }
                });

                if (length === 0) {
                    scope.notificationDisplayText = notificationStreamUtility.normalizeYouHaveText(notificationType, count);
                } else {
                    // Multiple Users
                    if (count > 2 || count > length) {
                        var userMultipleCount = length > 2 ? (count - 2) : (count - length);
                        scope.notificationDisplayText = notificationStreamUtility.normalizeMultipleDisplayText(notificationType, userOne, userTwo, userMultipleCount);
                        scope.requestConfirmedText = notificationStreamUtility.normalizeMultipleConfirmedText(notificationType, userOne, userTwo, userMultipleCount);
                        // Two Users
                    } else if (count === 2) {
                        scope.notificationDisplayText = notificationStreamUtility.normalizeDoubleDisplayText(notificationType, userOne, userTwo);
                        scope.requestConfirmedText = notificationStreamUtility.normalizeDoubleConfirmedText(notificationType, userOne, userTwo);
                        // One User
                    } else {
                        scope.notificationDisplayText = notificationStreamUtility.normalizeSingleDisplayText(notificationType, userOne);
                        scope.requestConfirmedText = notificationStreamUtility.normalizeSingleConfirmedText(notificationType, userOne);
                    }
                }
            }

            var actionTypeDistribution = function () {
                // check action Type based on event count and metadata
                scope.friendRequestActionType = notificationStreamUtility.friendRequestActionType;
                if (scope.notification.notificationSourceType === notificationStreamUtility.notificationSourceType.friendRequestReceived) {
                    if (length === 1 && count === 1 && !metaData[0].IsAccepted) {
                        scope.notification.friendRequestActionType = metaData[0].IsAccepted ?
                            notificationStreamUtility.friendRequestActionType.chatBtn
                            : notificationStreamUtility.friendRequestActionType.acceptIgnoreBtns;
                    } else if (length === 1 && count === 1 && metaData[0].IsAccepted) {
                        scope.notification.friendRequestActionType = notificationStreamUtility.friendRequestActionType.chatBtn;
                    } else {
                        scope.notification.friendRequestActionType = notificationStreamUtility.friendRequestActionType.viewAllBtn;
                    }
                } else if (scope.notification.notificationSourceType === notificationStreamUtility.notificationSourceType.friendRequestAccepted) {
                    if (length === 1 && count === 1) {
                        scope.notification.friendRequestActionType = notificationStreamUtility.friendRequestActionType.chatBtn;
                    }
                }
            }

            var init = function () {
                textFormat();
                actionTypeDistribution();
                scope.thumbnailTypes = thumbnailConstants.thumbnailTypes;
            }

            init();
        }
    }
}

notificationStreamModule.directive("friendRequest", friendRequest);

export default friendRequest;